import { useState, useEffect, useCallback } from 'react'
import { branchService } from '../services/branchService'
import type { BranchOffice } from '../types'

export function useBranches() {
  const [data, setData] = useState<BranchOffice[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const branches = await branchService.getAll()
      setData(branches)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar sucursales')
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, isLoading, error, refetch: fetchData }
}
